import { computed } from "vue"
import { useLicenceStore } from "~/store/licenceStore"

import { useProductVariantsStore } from "~/store/productVariantsStore"

export function useContentAccess(
  totalChildren?: number,
  productIsFree?: boolean,
) {
  const licenceStore = useLicenceStore()

  const products = useProductVariantsStore()

  const isSubjectFree = computed(() => {
    return totalChildren !== 0
  })

  const hasValidLicence = computed(() => {
    if (products.activeVariant?.ean) {
      return licenceStore.hasLicenceByEan(products.activeVariant.ean)
    }
    return false
  })

  const hasAccessWithoutLicence = computed(() => {
    return (
      (productIsFree || isSubjectFree.value) && !hasValidLicence.value
    )
  })

  const hasAccess = computed(() => {
    return hasAccessWithoutLicence.value || hasValidLicence.value
  })

  return {
    hasAccess,
    hasAccessWithoutLicence,
  }
}
